// CAT Mock 2 — DILR section.
const catMock2Dilr = [
  {
    id: 25,
    type: "mcq",
    setId: "di1",
    statement: `The table below shows the annual revenue (in ₹ crore) of five product lines of a company from 2021 to 2024.`,
    table: {
      columns: ["Product", "2021", "2022", "2023", "2024"],
      rows: [
        ["Alpha", "120", "135", "150", "180"],
        ["Beta", "90", "110", "100", "120"],
        ["Gamma", "60", "75", "90", "81"],
        ["Delta", "150", "140", "168", "175"],
        ["Epsilon", "80", "88", "96", "112"]
      ]
    },
    question: "Which product recorded the highest percentage growth in revenue from 2021 to 2024?",
    options: [
      "A. Alpha",
      "B. Beta",
      "C. Gamma",
      "D. Epsilon"
    ],
    answer: "A"
  },
  {
    id: 26,
    type: "tita",
    setId: "di1",
    question: "What was the total revenue (in ₹ crore) of all five products in 2023?",
    answer: "604"
  },
  {
    id: 27,
    type: "mcq",
    setId: "di1",
    question: "For how many products did revenue fall in at least one year compared with the previous year?",
    options: [
      "A. 1",
      "B. 2",
      "C. 3",
      "D. 4"
    ],
    answer: "C"
  },
  {
    id: 28,
    type: "tita",
    setId: "di1",
    question: "What percentage of the total 2021 revenue came from Delta? (Enter the number only.)",
    answer: "30"
  },
  {
    id: 29,
    type: "mcq",
    setId: "di1",
    question: "For how many products was the 2024 revenue more than 1.3 times the 2021 revenue?",
    options: [
      "A. 2",
      "B. 3",
      "C. 4",
      "D. 5"
    ],
    answer: "C"
  },
  {
    id: 30,
    type: "mcq",
    setId: "di2",
    statement: `Six friends — P, Q, R, S, T and U — sit around a circular table at equal distances, facing the centre. Each likes a different fruit among Apple, Banana, Cherry, Grape, Mango and Orange.
• Going clockwise, R is the person immediately after P.
• Q sits directly opposite P.
• T sits between R and Q (adjacent to both).
• U does not sit next to P.
• U likes Orange, and the person sitting directly opposite U likes Grape.
• S likes neither Mango nor Banana.
• The person who likes Cherry sits next to Q.
• Q does not like Mango.`,
    question: "Who sits directly opposite S?",
    options: [
      "A. P",
      "B. R",
      "C. U",
      "D. T"
    ],
    answer: "D"
  },
  {
    id: 31,
    type: "mcq",
    setId: "di2",
    question: "Which fruit does T like?",
    options: [
      "A. Apple",
      "B. Banana",
      "C. Cherry",
      "D. Grape"
    ],
    answer: "C"
  },
  {
    id: 32,
    type: "mcq",
    setId: "di2",
    question: "Who likes Apple?",
    options: [
      "A. P",
      "B. Q",
      "C. R",
      "D. S"
    ],
    answer: "D"
  },
  {
    id: 33,
    type: "tita",
    setId: "di2",
    question: "Counting clockwise from P, how many people sit between P and U?",
    answer: "3"
  },
  {
    id: 34,
    type: "mcq",
    setId: "di2",
    question: "Which of the following pairs sit next to each other?",
    options: [
      "A. S and U",
      "B. R and U",
      "C. P and Q",
      "D. T and S"
    ],
    answer: "A"
  },
  {
    id: 35,
    type: "mcq",
    setId: "di2",
    question: "If R and S exchange seats, who will sit directly opposite R?",
    options: [
      "A. P",
      "B. T",
      "C. Q",
      "D. U"
    ],
    answer: "B"
  },
  {
    id: 36,
    type: "tita",
    setId: "di3",
    statement: `In a survey of 200 students, 90 are members of the Music club, 70 of the Drama club and 80 of the Sports club. 30 students are in both Music and Drama, 25 in both Drama and Sports, and 35 in both Music and Sports. 10 students are members of all three clubs.`,
    question: "How many students are members of none of the three clubs?",
    answer: "40"
  },
  {
    id: 37,
    type: "mcq",
    setId: "di3",
    question: "How many students are members of exactly one club?",
    options: [
      "A. 80",
      "B. 90",
      "C. 95",
      "D. 100"
    ],
    answer: "B"
  },
  {
    id: 38,
    type: "tita",
    setId: "di3",
    question: "How many students are members of exactly two clubs?",
    answer: "60"
  },
  {
    id: 39,
    type: "mcq",
    setId: "di3",
    question: "How many students are members of Music and Sports but not Drama?",
    options: [
      "A. 20",
      "B. 25",
      "C. 30",
      "D. 35"
    ],
    answer: "B"
  },
  {
    id: 40,
    type: "mcq",
    setId: "di3",
    question: "What percentage of the surveyed students are members of at least two clubs?",
    options: [
      "A. 30%",
      "B. 35%",
      "C. 40%",
      "D. 45%"
    ],
    answer: "B"
  },
  {
    id: 41,
    type: "mcq",
    setId: "di4",
    statement: `Five candidates — Arun, Bina, Chetan, Divya and Esha — are interviewed on five consecutive days from Monday to Friday, one candidate per day. Each is interviewed for a job in a different city among Pune, Delhi, Chennai, Kolkata and Jaipur.
• Arun is interviewed on Wednesday.
• Bina is interviewed after Divya, but not on the day immediately after Arun.
• Chetan is interviewed before Esha.
• The Chennai interview is held on Thursday, and it is Divya's.
• The interview on Monday is for Pune.
• The Kolkata interview is held on the day immediately after the Chennai interview.
• Arun is not interviewed for Jaipur.`,
    question: "Who is interviewed on Tuesday?",
    options: [
      "A. Bina",
      "B. Chetan",
      "C. Divya",
      "D. Esha"
    ],
    answer: "D"
  },
  {
    id: 42,
    type: "tita",
    setId: "di4",
    question: "How many candidates are interviewed between Chetan and Divya?",
    answer: "2"
  },
  {
    id: 43,
    type: "mcq",
    setId: "di4",
    question: "For which city is Arun interviewed?",
    options: [
      "A. Pune",
      "B. Delhi",
      "C. Kolkata",
      "D. Jaipur"
    ],
    answer: "B"
  },
  {
    id: 44,
    type: "mcq",
    setId: "di4",
    question: "On which day is the Jaipur interview held?",
    options: [
      "A. Tuesday",
      "B. Monday",
      "C. Wednesday",
      "D. Friday"
    ],
    answer: "A"
  },
  {
    id: 45,
    type: "mcq",
    setId: "di4",
    question: "Which of the following combinations is NOT correct?",
    options: [
      "A. Bina – Kolkata – Friday",
      "B. Chetan – Pune – Monday",
      "C. Esha – Delhi – Tuesday",
      "D. Divya – Chennai – Thursday"
    ],
    answer: "C"
  },
  {
    id: 46,
    type: "tita",
    setId: "di4",
    question: "If Monday to Friday are numbered 1 to 5, what is the sum of the day numbers of Arun's and Bina's interviews?",
    answer: "8"
  }
];

export default catMock2Dilr;
